<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <!-- Form -->
  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="employeecontract.id"
        :hasError="!!errors.id"
        id="id"
      />

      <div class="form-col">
        <field
          :label="$t('employeecontract.employee_name')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <control
            :options="employeeList"
            :placeholder="$t('employeecontract.employee_name')"
            v-model="employeecontract.employee_id"
            id="employee_id"
            :hasError="!!errors.employee_id"
            required="required"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecontract.contract_type_name')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.contract_type_id"
        >
          <control
            :options="contractTypeList"
            :placeholder="$t('employeecontract.contract_type_name')"
            v-model="employeecontract.contract_type_id"
            id="contract_type_id"
            :hasError="!!errors.contract_type_id"
            required="required"
          />
        </field>
      </div>

      <div class="form-col">
       <field
          :label="$t('employeecontract.decree_no')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.decree_no"
        >
          <control
            type="text"
            :placeholder="$t('employeecontract.decree_no')"
            v-model="employeecontract.decree_no"
            :hasError="!!errors.decree_no"
            id="decree_no"
          />
        </field>
      </div>

      <div class="form-col">
       <field
          :label="$t('employeecontract.decree_date')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.decree_date"
        >
          <control
            type="date"
            v-model="employeecontract.decree_date"
            :hasError="!!errors.decree_date"
            id="decree_date"
          />
        </field>
      </div>

      <div class="form-col">
       <field
          :label="$t('employeecontract.period_start_date')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.period_start_date"
        >
          <control
            type="date"
            v-model="employeecontract.period_start_date"
            :hasError="!!errors.period_start_date"
            id="period_start_date"
          />
        </field>
      </div>

      <div class="form-col">
       <field
          :label="$t('employeecontract.period_end_date')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.period_end_date"
        >
          <control
            type="date"
            v-model="employeecontract.period_end_date"
            :hasError="!!errors.period_end_date"
            id="period_end_date"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecontract.employer_name')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employer_id"
        >
          <control
            :options="employeeList"
            :placeholder="$t('employeecontract.employer_name')"
            v-model="employeecontract.employer_id"
            id="employer_id"
            :hasError="!!errors.employer_id"
            required="required"
          />
        </field>
      </div>

      <div class="form-col">
       <field
          :label="$t('employeecontract.remarks_1')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.remarks_1"
        >
          <VueEditor
            :editorToolbar="customToolbar"
            v-model="employeecontract.remarks_1"
          />
        </field>
      </div>

      <div class="form-col">
       <field
          :label="$t('employeecontract.remarks_2')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.remarks_2"
        >
          <VueEditor
            :editorToolbar="customToolbar"
            v-model="employeecontract.remarks_2"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecontract.remarks_3')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.remarks_3"
        >
          <VueEditor
            :editorToolbar="customToolbar"
            v-model="employeecontract.remarks_3"
          />
        </field>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
</template>

<script>
/* eslint-disable */
import { ref, reactive, onMounted, watch } from "vue"
import axios from "axios"
import { mdiCheckBold } from "@mdi/js"
import Control from "@/components/Control"
import JbButton from "@/components/JbButton"
import JbButtons from "@/components/JbButtons"
import Field from "@/components/Field"
import Loading from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import { useToast } from "vue-toastification"
import { VueEditor } from "vue3-editor"

export default {
  name: "employeecontractForm",
  components: {
    Field,
    Control,
    Loading,
    JbButton,
    JbButtons,
    VueEditor,
  },
  props: {
    showEdit: { type: Boolean, default: false },
    propEmployeeContract: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  emits: ["close-modal", "reset-modal", "refresh-list"],
  setup(props, { emit }) {
    const isLoading = ref(false)
    const toast = useToast()
    const errors = ref({})
    const userlogin = localStorage.getItem("name")
    const darkMode = ref(false)

    const employeeList = ref([])
    const contractTypeList = ref([])

    const employeecontract = reactive({
      id: null,
      employee_id: "",
      employer_id: "",
      contract_type_id: "",
      decree_no: "",
      decree_date: "",
      period_start_date: "",
      period_end_date: "",
      remarks_1: "",
      remarks_2: "",
      remarks_3: "",
      created_by: "",
      updated_by: "",
    })

    const reset = () => {
      Object.assign(employeecontract, {
        id: null,
        employee_id: "",
        employer_id: "",
        contract_type_id: "",
        decree_no: "",
        decree_date: "",
        period_start_date: "",
        period_end_date: "",
        remarks_1: "",
        remarks_2: "",
        remarks_3: "",
        created_by: "",
        updated_by: "",
      })
      errors.value = {}
    }

    const fetchExistingData = async (id) => {
      try {
        isLoading.value = true

        const response = await axios.get("/employeecontract", {
          params: { id },
        })

        if (response.data.success && response.data.data) {
          const data = response.data.data

          Object.assign(employeecontract, {
            id: data.id || employeecontract.id,
            employee_id: data.employee_id || employeecontract.employee_id,
            employer_id: data.employer_id || employeecontract.employer_id,
            contract_type_id: data.contract_type_id || employeecontract.contract_type_id,
            decree_no: data.decree_no || employeecontract.decree_no,
            decree_date: data.decree_date || employeecontract.decree_date,
            period_start_date: data.period_start_date || employeecontract.period_start_date,
            period_end_date: data.period_end_date || employeecontract.period_end_date,
            remarks_1: data.remarks_1 || employeecontract.remarks_1,
            remarks_2: data.remarks_2 || employeecontract.remarks_2,
            remarks_3: data.remarks_3 || employeecontract.remarks_3,
            created_by: data.created_by || employeecontract.created_by,
            updated_by: data.updated_by || employeecontract.updated_by,
          })
        }
      } catch (err) {
        toast.error("Failed to load employee contract")
        console.error(err)
      } finally {
        isLoading.value = false
      }
    }

    watch(
      () => props.propEmployeeContract,
      (val) => {
        if (!val || val.empty) {
          reset()
          return
        }

        if (props.showEdit && val.id) {
          employeecontract.id = val.id
          fetchExistingData(val.id)
        } else if (!props.showEdit && val.employee_id) {
          Object.assign(employeecontract, {
            id: null,
            employee_id: val.employee_id || "",
            employer_id: val.employer_id || "",
            contract_type_id: val.contract_type_id || "",
            decree_no: val.decree_no || "",
            decree_date: val.decree_date || "",
            period_start_date: val.period_start_date || "",
            period_end_date: val.period_end_date || "",
            remarks_1: val.remarks_1 || "",
            remarks_2: val.remarks_2 || "",
            remarks_3: val.remarks_3 || "",
            created_by: "",
            updated_by: "",
          })
        }
      },
      { immediate: true, deep: true }
    )

    const store = async () => {
      if (props.showEdit && !employeecontract.id) {
        toast.error("ID not found for edit mode.")
        return
      }

      isLoading.value = true

      const method = employeecontract.id ? "PUT" : "POST"
      const url = employeecontract.id
        ? `/employeecontract/${employeecontract.id}`
        : "/employeecontract"

      if (method === "POST") {
        employeecontract.created_by = userlogin
      } else {
        employeecontract.updated_by = userlogin
      }

      try {
        const res = await axios({ method, url, data: employeecontract })

        if (res.data.success) {
          toast.success(res.data.message)
          emit("refresh-list")
          emit("reset-modal")
          emit("close-modal")
        } else {
          errors.value = res.data.errors || {}
          toast.error(res.data.message || "Failed to save data")
        }

        if (!employeecontract.id) reset()
      } catch (err) {
        errors.value = err.response?.data?.errors || {}
        toast.error(err.response?.data?.message || "Error occurred")
        console.error(err)
      } finally {
        isLoading.value = false
      }
    }

    const getEmployee = async () => {
      try {
        isLoading.value = true
        const userId = localStorage.getItem('user_id')
        const branchId = localStorage.getItem('branch_id')

        if (!userId) {
          toast.error("User ID not found in local storage.")
          isLoading.value = false
          return
        }

        const response = await axios.get("employee", {
          params: { user_id: userId, branch_id: branchId },
          headers: { "Content-Encoding": "gzip" },
        })

        if (response.data.success && Array.isArray(response.data.data)) {
          employeeList.value = response.data.data
        } else {
          toast.error("Failed to fetch employee data.")
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            "Failed to load employee contract data"
        )
        console.error(error)
      } finally {
        isLoading.value = false
      }
    }

    const getContractType = async () => {
      try {
        isLoading.value = true
        const res = await axios.get("/contract-type")
        contractTypeList.value = res.data.data || []
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load data")
        console.error(err)
      } finally {
        isLoading.value = false
      }
    }

    onMounted(() => {
      getEmployee()
      getContractType()
    })

    return {
      isLoading,
      employeecontract,
      errors,
      mdiCheckBold,
      store,
      reset,
      employeeList,
      contractTypeList,
      darkMode,
    }
  },
}
</script>